<template>
  <div class="RankList">
    <div class="noitem" v-if="ranks.length==0">暂无排名</div>
    <item v-for="r in ranks" :key="r.rank" :item="r" :undo="undo"></item>
  </div>
</template>

<script>
 import ListItem from './listItem.vue'
export default {
  name: 'RankList',
  props: ['ranks', 'undo'],
  components: {
     item: ListItem
   }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .RankList {
   display: flex;
   flex-direction: column;
   align-items:center;
 }
 .noitem{
   color: rgba(255,255,255, 0.7);
   line-height: 4em;
 }
</style>
